import './polyfills.ts';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { AlRuntimeConfiguration, ConfigOption, AlLocation } from '@al/core';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';

AlRuntimeConfiguration.setOption( ConfigOption.GestaltAuthenticate, true );

try {
    let verifyMfaRouteMatcher = /\?state=(.*)\#\/mfa\/verify(.*)/;
    let acceptTosRouteMatcher = /\?state=(.*)\#\/terms-of-service(.*)/;
    let w = <any>window;
    let originalURL = w.location.href;

    if ( w.location.href.match( verifyMfaRouteMatcher ) ) {
        let matches = verifyMfaRouteMatcher.exec( w.location.href );
        let stateValue = matches[1];
        let qsValue = matches[2];
        let rewrittenURL = w.location.href.replace( verifyMfaRouteMatcher, `#/mfa/verify${qsValue}&state=${stateValue}` );
        w.location.replace( rewrittenURL );
    } else if ( w.location.href.match( acceptTosRouteMatcher ) ) {
        let matches = acceptTosRouteMatcher.exec( w.location.href );
        let stateValue = matches[1];
        let qsValue = matches[2];
        let rewrittenURL = w.location.href.replace( acceptTosRouteMatcher, `#/terms-of-service${qsValue}&state=${stateValue}` );
        w.location.replace( rewrittenURL );
    }
} catch( e ) {
    console.warn("Unexpected error: could not preprocess application URI: " + e.toString() );
}

const playbookFilters = [
    'statuses',
    'playbook_ids',
    'playbook_types',
    'deployments',
    'display_names',
    'types',
    'startDate',
    'endDate',
    'trigger_ids',
    'action_names',
    'action_display_names',
    'type',
    'enabled',
    'vendors',
    'category',
    'status',
    'bk_location_type',
    'bk_location_id',
    'trigger_types',
    'task_names',
    'response',
    'query',
];

AlRuntimeConfiguration.addParamPreservationRule( "playbook-history", {
    applyTo: [
        /^\/automated-response\/history\/.*/,
        /^\/automated-response\/history-detail\/.*/
    ],
    volatile: playbookFilters
});

AlRuntimeConfiguration.addParamPreservationRule( "playbook-inquiries", {
    applyTo: [
        /^\/automated-response\/inquiries\/.*/
    ],
    volatile: playbookFilters
});

AlRuntimeConfiguration.addParamPreservationRule( "playbook-triggers", {
    applyTo: [
        /^\/automated-response\/triggers\/.*/
    ],
    volatile: playbookFilters
});

AlRuntimeConfiguration.addParamPreservationRule( "playbooks", {
    applyTo: [
        /^\/automated-response\/playbooks\/.*/
    ],
    volatile: playbookFilters
});

AlRuntimeConfiguration.addParamPreservationRule("simple-responses", {
    applyTo: [
        /^\/automated-response\/simple-responses\/.*/
    ],
    volatile: playbookFilters
});

AlRuntimeConfiguration.addParamPreservationRule("simple-history", {
    applyTo: [
        /^\/automated-response\/simple-history\/.*/
    ],
    volatile: playbookFilters
});

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
